'use client'
import Script from 'next/script'
import { GoogleTagManager } from '@next/third-parties/google'

interface ScriptProps {
  gtmId?: string
  hjid?: number
  hjsv?: number
  adoptId?: string
  tintimId?: string
}

export default function Scripts({
  gtmId,
  hjid,
  hjsv,
  adoptId,
  tintimId,
}: ScriptProps) {
  return (
    <>
      {gtmId && !/toBeGenerated/i.test(gtmId) && (
        <GoogleTagManager gtmId={gtmId} />
      )}

      {hjid && (
        <Script
          id="hotjar"
          strategy="lazyOnload"
          onError={() => console.error('Hotjar script failed')}
          crossOrigin="anonymous"
        >
          {`
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script'); r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
        </Script>
      )}

      {adoptId && !/toBeGenerated/i.test(adoptId) && (
        <Script
          id="adopt"
          strategy="lazyOnload"
          src={`https://tag.goadopt.io/injector.js?website_code=${adoptId}`}
          onError={() => console.error('Adopt failed to load')}
          crossOrigin="anonymous"
        />
      )}
      {tintimId && (
        <Script id={tintimId} strategy="lazyOnload">
          {`(function(window, document, script) {
        if (!window.tt) {
            window.tt = window.tt || {};

            c = document.getElementsByTagName('head')[0];
            k = document.createElement('script');
            k.async = 1;
            k.src = script;
            c.appendChild(k);
        }

        window.tt.accountCode = 'd67fc36a-3abd-4262-a6ac-a3b65f56c304';

    })(window, document, '//s.tintim.app/static/core/tintim-1.0.js');`}
        </Script>
      )}
    </>
  )
}
